import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Horses} from '../../../../../../@shared/services/horses';
import {AQH_HOR_1, AQH_HOR_2, AQH_HOR_4} from '../../../../../../@shared/models/input.module';
import {HorseResponse} from '../../../../../../@shared/models/response.module';
import {toYMD} from '../../../../../../@core/utils/utils.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

function formatDateyyyyMMdd(date_of_birth: Date | null) {
  if (!date_of_birth) return null;
  const d = new Date(date_of_birth);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

@Component({
  selector: 'app-edit-horse',
  standalone: false,
  templateUrl: './edit-horse.html',
  styleUrl: './edit-horse.css'
})
export class EditHorse implements OnChanges {
  @Input() horse: HorseResponse

  horseRegistries = [
    { label: 'AQHA', value: 0 },
    { label: 'APHA', value: 1 },
    { label: 'ApHC', value: 2 },
    { label: 'Other', value: 3 },
  ]

  horseGenders = [
    { label: 'Gelding', value: 0 },
    { label: 'Stallion', value: 1 },
    { label: 'Mare', value: 2 },
  ]

  name = '';
  date_of_birth = ""
  passport_id = '';
  breed = '';
  color = '';
  vaccination_date = ""
  next_vaccination_date = ""

  selectedRegistry: any = null;
  selectedGender: any = null;

  horseImageFile: File | null = null;
  pedigreeFile: File | null = null;
  vaccinationCardFile: File | null = null;


  constructor(private horseService: Horses,
              private modal: NgbActiveModal) {
  }

  ngOnInit() {
    console.log("HORSE TO EDIT:", this.horse)
    if (this.horse) {
      this.name = this.horse.name ?? '';
      this.date_of_birth = toYMD(this.horse.date_of_birth);
      this.passport_id = this.horse.passport_id ?? '';
      this.breed = this.horse.breed ?? '';
      this.color = this.horse.color ?? '';
      this.vaccination_date = toYMD(this.horse.vaccination_date);
      this.next_vaccination_date = toYMD(this.horse.next_vaccination_date);
      this.selectedRegistry = this.horse.horse_registry_id;
      this.selectedGender = this.horse.gender;
    }

    console.log("selectedGender:", this.selectedGender)
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("HORSE TO EDIT:", this.horse)
    if (this.horse) {
      this.name = this.horse.name ?? '';
      this.date_of_birth = toYMD(this.horse.date_of_birth);
      this.passport_id = this.horse.passport_id ?? '';
      this.breed = this.horse.breed ?? '';
      this.color = this.horse.color ?? '';
      this.vaccination_date = toYMD(this.horse.vaccination_date);
      this.next_vaccination_date = toYMD(this.horse.next_vaccination_date);
      this.selectedRegistry = this.horse.horse_registry_id;
      this.selectedGender = this.horse.gender;
    }

    console.log("selectedGender:", this.selectedGender)
  }

  private toISO(date: string): string {
    if (!date) return '';
    // Handle full ISO strings (2025-10-12T00:00:00.000Z)
    if (date.includes('T')) {
      return date.split('T')[0]; // → "2025-10-12"
    }
    // Already YYYY-MM-DD (from input type="date")
    return date;
  }

  onSave() {
    console.log("Saving horse...");
    const payload: AQH_HOR_2 = {
      horse_id: this.horse.horse_id,
      name: this.name.trim(),
      date_of_birth: this.date_of_birth!,
      passport_id: this.passport_id.trim(),
      horse_registry_id: this.selectedRegistry?.value ?? 0,
      gender: this.selectedGender,
      breed: this.breed.trim(),
      color: this.color.trim(),
      vaccination_date: this.vaccination_date!,
      next_vaccination_date: this.next_vaccination_date!,
      owner_name: "",
      owner_phone_number: "",
      image_url: '',
      pedigree_image_url: '',
      vaccination_card_url: '',
    };

    this.horseService.editHorse(payload).subscribe((res) => {
      console.log('Horse edited:', res);
      let horse = res;
      if (this.horseImageFile) {
        let payload: AQH_HOR_4 = {
          horse_id: res.horse_id,
          image_type: 'horse_image',
          image: this.horseImageFile
        }
        this.horseService.uploadHorseImage(payload).subscribe((res) => {
          console.log('Horse image uploaded:', res)
          horse = res
        });
      }
      if (this.pedigreeFile) {
        let payload: AQH_HOR_4 = {
          horse_id: res.horse_id,
          image_type: 'pedigree_image',
          image: this.pedigreeFile
        }
        this.horseService.uploadHorseImage(payload).subscribe((res) => {
          console.log('Pedigree image uploaded:', res)
          horse = res
        });
      }
      if (this.vaccinationCardFile) {
        let payload: AQH_HOR_4 = {
          horse_id: res.horse_id,
          image_type: 'vaccination_image',
          image: this.vaccinationCardFile
        }
        this.horseService.uploadHorseImage(payload).subscribe((res) => {
          console.log('Vaccination image uploaded:', res)
          horse = res
        });
      }
      this.modal.close(true)
    })
  }

  close() {
    this.modal.close();
  }
}

function fromApiDate(v?: string | null): string {
  if (!v) return ''; // always return a string
  try {
    const parsed = new Date(v);
    if (isNaN(parsed.getTime())) {
      const [datePart] = v.split(',');
      const [month, day, year] = datePart.split('/').map(x => x.trim());
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    const y = parsed.getFullYear();
    const m = String(parsed.getMonth() + 1).padStart(2, '0');
    const d = String(parsed.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  } catch {
    return '';
  }
}
